import React, { useRef, useState } from "react";
import { UploadSimple } from "@phosphor-icons/react";
import { api, fileUrl } from "../../lib/api";
import { toast } from "sonner";

export default function ImageUploader({ value, onChange, folder = "gallery", label = "Image" }) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("folder", folder);
      const res = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.path);
      toast.success("Uploaded");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Upload failed");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <div className="admin-label">{label}</div>
      <div className="flex items-start gap-4">
        {value ? (
          <img src={fileUrl(value)} alt="" className="h-24 w-32 object-cover border border-[#333]" data-testid="upload-preview" />
        ) : (
          <div className="h-24 w-32 border border-dashed border-[#333] flex items-center justify-center text-white/30 text-xs font-mono uppercase">None</div>
        )}
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => inputRef.current?.click()}
            disabled={busy}
            className="inline-flex items-center gap-2 border-2 border-atc-red text-atc-red hover:bg-atc-red hover:text-white px-4 py-2 font-heading uppercase tracking-widest text-xs font-bold disabled:opacity-50"
            data-testid="upload-btn"
          >
            <UploadSimple size={16} weight="bold" /> {busy ? "Uploading…" : value ? "Replace" : "Upload"}
          </button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="text-white/50 hover:text-atc-red text-xs font-mono uppercase tracking-widest" data-testid="upload-clear">Clear</button>
          )}
          <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} data-testid="upload-input" />
        </div>
      </div>
    </div>
  );
}
